import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  addResourcePoolPolicy(rpId, vcId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/resourcepool/' + rpId + '/policy';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }

  updateResourcePoolPolicy(rpId, vcId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/resourcepool/' + rpId + '/policy';
    return this.http
      .put(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }

  addVmPolicy(vmId, vcId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/policy';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }

  updateVmPolicy(vmId, vcId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/policy';
    return this.http
      .put(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/apply-policy/apply-policy.service.ts